import { getTotalArea } from './getTotalArea';
import { IOfferCard } from '../../../types/card';

export function getOfferArea(offerCard: IOfferCard): string | undefined {
  const totalArea = getTotalArea(offerCard);

  if (totalArea) {
    return `${totalArea} м²`;
  }

  return undefined;
}
